/* eslint-disable react-hooks/exhaustive-deps */
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Box,
    Checkbox,
    Flex,
    Button,
    Text,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Switch,
} from '@chakra-ui/react';
import { FiEdit } from 'react-icons/fi';
import { useEffect, useMemo, useState } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { BiCopy } from 'react-icons/bi';
import { AiOutlineDelete } from 'react-icons/ai';
import { RxDashboard } from 'react-icons/rx';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isObject } from 'formik';
import { add_to_store } from 'redux/actions/storeActions';
import FullPagination from 'components/Dashboard/FullPagination';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';

export default function SelectionTable() {
    const [tableData, setTableData] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const storeReducer = useSelector((state) => state.storeReducer);
    const { store } = storeReducer;

    useEffect(() => {
        const storeProducts = store?.storeProducts;
        if (!storeProducts) {
            navigate('/dashboard/store/products');
        }
        const mutatedData = storeProducts?.map((storeProduct) => {
            const objectKeys = ['general', 'inventry', 'pricing', 'variant'];
            for (let objectKey of objectKeys) {
                if (storeProduct[objectKey] && !isObject(storeProduct[objectKey]))
                    storeProduct[objectKey] = JSON.parse(storeProduct[objectKey]);
            }
            return { ...storeProduct, isChecked: false };
        });
        setTableData(mutatedData);
    }, []);

    const mutateTableData = (storeProductId) => {
        const mutatedOrders = tableData.map((storeProduct) => {
            if (storeProduct.id === storeProductId) {
                return {
                    ...storeProduct,
                    isChecked: !storeProduct.isChecked,
                };
            }
            return storeProduct;
        });
        setTableData(mutatedOrders);
    };

    const selectAll = (checked) => {
        const mutatedOrders = tableData.map((storeProduct) => {
            return {
                ...storeProduct,
                isChecked: checked,
            };
        });
        setTableData(mutatedOrders);
        setIsSelectAll(checked);
    };

    const tableFilter = useMemo(() => {
        const result = tableData?.filter((data) => data.isChecked);
        const length = result.length;
        return { result, length };
    }, [tableData]);

    const dStoreFront = (item, status = null, isGouped = false) => {};

    const pushToStoreFront = (e, status = null, isGouped = false) => {
        const mutatedOrders = tableData.map((storeProduct) => {
            if (storeProduct.id === e.id || (isGouped && storeProduct.isChecked)) {
                storeProduct.status = status ? status : e.checked ? 'enabled' : 'disabled';
                dispatch(add_to_store(storeProduct));
            }
            return storeProduct;
        });
        setTableData(mutatedOrders);
    };

    return (
        <Box mt="5">
            <TableContainer border="1px solid #EAECF0" borderRadius="lg">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr>
                            <Th py="4">
                                <Checkbox
                                    mr="0"
                                    isChecked={isSelectAll}
                                    onChange={(e) => selectAll(e.target.checked)}
                                />
                            </Th>
                            <Th py="4">SKU Number</Th>
                            <Th py="4">Product</Th>
                            <Th py="4">Category</Th>
                            <Th py="4">Quantity</Th>
                            <Th py="4">Price</Th>
                            <Th py="4">On Sale</Th>
                            <Th py="4">Push to store</Th>
                            <Th py="4">Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {tableData?.map((storeProduct) => (
                            <Tr fontSize="xs" key={storeProduct.id}>
                                <Td py="6" pr="0">
                                    <Checkbox
                                        mr="0"
                                        onChange={() => mutateTableData(storeProduct.id)}
                                        isChecked={storeProduct?.isChecked}
                                    />
                                </Td>
                                <Td py="6">
                                    {storeProduct?.inventry?.prefered_sku || storeProduct?.sku}
                                </Td>
                                <Td py="6">
                                    {storeProduct?.general?.prefered_name ||
                                        storeProduct?.general?.name}
                                </Td>
                                <Td py="6">{storeProduct?.general?.category}</Td>
                                <Td py="6">{storeProduct?.inventry?.quantity}</Td>
                                <Td py="6">
                                    <WalletHistoryPrice
                                        price={storeProduct?.pricing?.regular_price}
                                    />
                                </Td>
                                <Td py="6">
                                    <WalletHistoryPrice price={storeProduct?.pricing?.sale_price} />
                                </Td>
                                <Td py="6" textAlign="center">
                                    <Switch
                                        id={storeProduct.id}
                                        colorScheme="teal"
                                        size="lg"
                                        isChecked={storeProduct?.status === 'enabled'}
                                        checked={storeProduct?.status === 'enabled'}
                                        onChange={(e) => pushToStoreFront(e.target)}
                                    />
                                </Td>
                                <Td py="6" textAlign="center">
                                    <Menu>
                                        <MenuButton
                                            as={Button}
                                            cursor="pointer"
                                            bg="#fff"
                                            borderRadius="full">
                                            <BsThreeDots />
                                        </MenuButton>
                                        <MenuList>
                                            <MenuItem icon={<FiEdit />}>Edit product</MenuItem>
                                            <MenuItem icon={<BiCopy />}>Copy product link</MenuItem>
                                            <MenuItem
                                                onClick={() => dStoreFront(storeProduct, 'deleted')}
                                                icon={<AiOutlineDelete />}>
                                                Delete
                                            </MenuItem>
                                        </MenuList>
                                    </Menu>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>

                {tableFilter.length ? (
                    <Flex
                        px="10"
                        alignItems="center"
                        fontSize="sm"
                        fontWeight="medium"
                        w="full"
                        py="4"
                        justifyContent="space-between">
                        <Flex alignItems="center" gap="3">
                            <Text>{tableFilter.length} selected</Text>
                            <Button
                                onClick={() => selectAll(false)}
                                isDisabled={!tableFilter.length}>
                                Deselect
                            </Button>
                        </Flex>
                        <Flex gap="3">
                            <Button
                                bg="#FFF0F0"
                                leftIcon={<AiOutlineDelete />}
                                color="#FF0100"
                                _hover={{
                                    bg: '#FF0100',
                                    color: '#FFF0F0',
                                    border: '1px solid #FFF0F0',
                                }}
                                fontWeight="400">
                                Delete
                            </Button>
                            <Button
                                bg="#1b3b5f"
                                leftIcon={<RxDashboard />}
                                color="#fff"
                                _hover={{
                                    bg: '#fff',
                                    color: '#1b3b5f',
                                    border: '1px solid #1b3b5f',
                                }}
                                fontWeight="400">
                                Push to store &#40;{tableFilter.length}&#41;
                            </Button>
                        </Flex>
                    </Flex>
                ) : (
                    <FullPagination handlePageClick={() => null} fullData={tableData} />
                )}
            </TableContainer>
            <Box p="3">{}</Box>
        </Box>
    );
}
